import { LOCALES } from '@deskworks/shared-types';
import { Check, Languages } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { LOCALE_NAMES, locale, setLocale, t } from '@/lib/i18n';

/** The language of the pages without a profile (landing page, sign-in); signed-in people choose theirs in the profile. */
export function LanguageSwitch() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" aria-label={t('Language')} className="gap-1.5 px-2 text-muted-foreground">
          <Languages /> {locale.toUpperCase()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LOCALES.map((l) => (
          <DropdownMenuItem key={l} onSelect={() => setLocale(l)} lang={l}>
            <Check className={l === locale ? undefined : 'invisible'} /> {LOCALE_NAMES[l]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
